import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { Route, Redirect } from 'react-router-dom'
import * as routerPath from './LB/constants/routePaths'
import api from "./LB/api/api";
import loginApi from "./LB/api/loginApi";

class AuthRouter extends Component {

    constructor(props) {
        super(props);

        this.state = {
            expiredTriggered: false,
            hasTriggered: false,
            isGettingLoggedIn: true,
            isLoggedIn: false,
        }
    }

    /**
     * Get if the user is logged in.
     * @returns 
     */
    getIsLoggedIn = () => {
        let s = this.state;

        if (s.isGettingLoggedIn === true) return true;

        if (s.isGettingLoggedIn === false && s.isLoggedIn) return true;

        return false;
    }

    /**
     * Perform the is user logged in check.
     * TODO: Future improvement would be to capture if the token expiry fails because its only checking if the access token exists, not if its the expired one.
     * @returns 
     */
    performGetIsLoggedIn = () => {
        let s = this.state;
        let isExpired = loginApi.checkIsExpiredToken();

        // reset expired trigger
        if (!isExpired && s.expiredTriggered)
        {
            this.setState({
                expiredTriggered: false,
            })
        }

        let skipCheck = s.hasTriggered && ((isExpired && s.expiredTriggered) || !isExpired)

        if (skipCheck) return;

        this.setState({
            expiredTriggered: isExpired,
            hasTriggered: true,
        });

        let prom = api.getUserToken();
        prom.then(accessToken => {
            if (accessToken === null || accessToken === undefined || accessToken === "") {
                this.setState({
                    isGettingLoggedIn: false,
                    isLoggedIn: false,
                });
            } else {
                this.setState({
                    isGettingLoggedIn: false,
                    isLoggedIn: true,
                });
            }
        });
    }

    render() {
        const { component: Component, ...rest } = this.props
        const isLogged = this.getIsLoggedIn();

        this.performGetIsLoggedIn();

        return (
            <Route {...rest} render={props => {
                return isLogged
                    ? <Component {...props} />
                    : <Redirect to={routerPath.INDEX} />
            }} />
        )
    }
}

export default withRouter(AuthRouter); 